import {useForm} from 'react-hook-form';
import {useId} from 'react';
import {Form} from '@common/ui/forms/form';
import {AccountSettingsPanel} from '@common/auth/ui/account-settings/account-settings-panel';
import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';
import {UpdatePasswordPayload, useUpdatePassword} from './use-update-password';
import {Button} from '@common/ui/buttons/button';
import {Trans} from '@common/i18n/trans';
import {AccountSettingsId} from '@common/auth/ui/account-settings/account-settings-sidenav';
import React, { useState } from 'react';

export function ChangePasswordPanel() {
  const form = useForm<UpdatePasswordPayload>();
  const formId = useId();
  const updatePassword = useUpdatePassword(form);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <AccountSettingsPanel
      id={AccountSettingsId.Password}
      title={<Trans message="Update password" />}
      // actions={
      //   <Button
      //     type="submit"
      //     form={formId}
      //     variant="flat"
      //     color="primary"
      //     disabled={!form.formState.isValid || updatePassword.isPending}
      //   >
      //     <Trans message="Update password" />
      //   </Button>
      // }
    >
      <Form
        form={form}
        id={formId}
        onSubmit={newValues => {
          updatePassword.mutate(newValues, {
            onSuccess: () => {
              form.reset();
            },
          });
        }}
      >


        <div className='accountframe'>
          <div className='accountframeInside'>
              <div className='accountframeInsideTitle'>Şifre</div>
              <div className='accountframeInsideText'>*****</div>
          </div>
          <button onClick={handleOpenModal}  type='button' className='accountframeInsideButton'>Düzenle</button>
      <dialog open={isModalOpen} className="modal">
        <div className="modal-content">
          <span className="close" onClick={handleCloseModal}>&times;</span>
          <h2 className='modal_dialog_title'>Şifre</h2>
          <div className="flex-auto w-full">
          <FormTextField
          className="mb-24"
          name="current_password"
          label={<Trans message="Güncel şifre" />}
          type="password"
          autoComplete="current-password"
          required
          placeholder='Şifre'
        />
        <FormTextField
          className="mb-24"
          name="password"
          label={<Trans message="Yeni şifre" />}
          type="password"
          autoComplete="new-password"
          required
          placeholder='Yeni şifre'
        />
        <FormTextField
          name="password_confirmation"
          label={<Trans message="Yeni şifre tekrar" />}
          type="password"
          autoComplete="new-password"
          required
          placeholder='Yeni şifre tekrar'
        /><br></br>
          <button className='modal_dialog_save_button'>Kaydet</button>          
        </div>
        </div>
      </dialog>
        </div>



       
      </Form>
    </AccountSettingsPanel>
  );
}
